import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { GameManager } from "../GameManager";

export class BootScene extends Phaser.Scene {

    public static currentInstance: BootScene;
    private static bootedInWrongOrientation: boolean;

    private static enterIncorrectOrientation(): void {
        document.getElementById("orientation").style.display = "block";
    }

    private static leaveIncorrectOrientation(): void {

        document.getElementById("orientation").style.display = "none";

        if (BootScene.bootedInWrongOrientation) {

            BootScene.bootedInWrongOrientation = false;
            BootScene.currentInstance.setScaleFactor();
            BootScene.currentInstance.scene.restart();
        }
    }

    constructor() {

        super("BootScene");
    }

    public create(): void {

        BootScene.currentInstance = this;
        GameVars.currentScene = this;
        GameVars.currentDrawCategory = "ANIMALS";

        GameVars.recentDrawFinishedCategoryID = -1;
        GameVars.recentDrawFinishedID = -1;

        GameVars.aspectRatio = BootScene.currentInstance.game.scale.displaySize.height / BootScene.currentInstance.game.scale.displaySize.width;

        if (this.sys.game.device.os.desktop) {

            GameVars.scaleXMult = 1;
            GameVars.scaleYMult = 1;
            GameVars.scaleXMultInverse = 1;
            GameVars.scaleYMultInverse = 1;
            GameVars.correctionScale = 1;

        } else {

            this.game.scale.on("orientationchange", this.checkOrientation, BootScene.currentInstance);
            this.checkOrientation(this.game.scale.orientation, true);

            window.addEventListener("orientationchange", () => { this.checkOrientation(null, false); });

            BootScene.currentInstance.game.scale.displaySize = BootScene.currentInstance.game.scale.parentSize;
            this.setScaleFactor();
            BootScene.currentInstance.game.scale.refresh();
        }

        GameManager.init();
    }

    public preload(): void {

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
    }

    public setScaleFactor(): void {

        const aspectRatio = BootScene.currentInstance.game.scale.displaySize.height / BootScene.currentInstance.game.scale.displaySize.width;
        const scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / aspectRatio;

        GameVars.correctionScale = 1;

        if (aspectRatio <= 1.50) {
            GameVars.correctionScale = .75;
        } else if (aspectRatio <= 1.55) {
            GameVars.correctionScale = .8;
        } else if (aspectRatio <= 1.65) {
            GameVars.correctionScale = .9;
        }

        GameVars.scaleYMult = scaleY * GameVars.correctionScale;
        GameVars.scaleXMult = GameVars.correctionScale;
        GameVars.scaleYMultInverse = 1 / GameVars.scaleYMult;
        GameVars.scaleXMultInverse = 1 / GameVars.scaleXMult;
        GameVars.aspectRatio = aspectRatio;
    }

    private checkOrientation(orientation: Phaser.Scale.OrientationType, initialCheck: boolean = false) {

        let landscape: boolean;

        if (orientation !== null) {
            landscape = orientation === Phaser.Scale.LANDSCAPE;
        } else {
            landscape = window.innerWidth > window.innerHeight;
        }

        if (!landscape) {

            BootScene.leaveIncorrectOrientation();

        } else {

            BootScene.enterIncorrectOrientation();

            if (initialCheck) {
                BootScene.bootedInWrongOrientation = true;
            }
        }
    }
}
